module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/point01-f6788da3cafa37900a737b042d31731e.png";